import { motion } from 'framer-motion';
import { Users, Calendar, MessageCircle, TrendingUp, Award, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function MembershipBenefits() {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: Calendar,
      title: 'Exclusive Events',
      description: 'Access property site visits, investment workshops, and networking events with industry leaders.'
    },
    {
      icon: Users,
      title: 'Elite Network',
      description: 'Connect with CEOs, doctors, lawyers, and business professionals with aligned investment goals.'
    },
    {
      icon: MessageCircle,
      title: 'Expert Consultation',
      description: 'Complimentary portfolio review and investment advice from real estate specialists.'
    },
    {
      icon: TrendingUp,
      title: 'Market Insights',
      description: 'Monthly reports on market trends, new opportunities, and property performance analytics.'
    },
    {
      icon: Award,
      title: 'Priority Access',
      description: 'Early access to new property listings before they become available to the public.'
    },
    {
      icon: Shield,
      title: 'Investment Protection',
      description: 'Comprehensive due diligence, legal verification, and transparent reporting on all properties.'
    }
  ];

  return (
    <div className="py-24 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#4ADE80]/10 border border-[#4ADE80]/20 rounded-full mb-6">
            <Award className="w-4 h-4 text-[#4ADE80]" />
            <span className="text-sm text-[#4ADE80] font-medium">Members-Only Benefits</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-light mb-4">Join Smart Investors</h2>
          <p className="text-white/60 max-w-2xl mx-auto">
            Our members include entrepreneurs, professionals, and wealth creators who understand the power of fractional real estate investing.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-[#111111] border border-white/5 rounded-xl p-6 hover:border-white/20 transition-colors duration-300"
              >
                <div className="w-12 h-12 bg-[#4ADE80]/10 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-[#4ADE80]" />
                </div>
                <h3 className="text-lg font-medium mb-3">{benefit.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{benefit.description}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-white/60 mb-6">No cost to join. Start investing in premium real estate today.</p>
          <Button 
            onClick={() => navigate('/auth')}
            className="bg-white text-black hover:bg-gray-200 font-medium px-8 py-6 text-base rounded-full transition-all duration-300 hover:scale-105"
          >
            Become a Member
          </Button>
        </div>
      </div>
    </div>
  );
}